module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/2-1ffaa8a4951ec874370a6b929ec523df.webp";